import { Navigate, Outlet, useParams } from 'react-router-dom';

import type { FeatureName } from 'hooks/useFeatures';
import { useFeatures } from 'hooks/useFeatures';

import { Loading } from 'components/pages/Loading';

type Props = {
  featureFlag: FeatureName;
};

export const RequireFeatureFlag = ({ featureFlag }: Props) => {
  const { organisationId } = useParams();
  const { getFeatureFlag, isLoading, isError, isSuccess } = useFeatures();

  const isFeatureEnabled = !!getFeatureFlag(featureFlag);

  return (
    <>
      {isLoading && <Loading text="Loading data..." />}
      {isError && <Navigate to={`/org/${organisationId}`} replace />}
      {isSuccess &&
        (isFeatureEnabled ? (
          <Outlet />
        ) : (
          <Navigate to={`/org/${organisationId}`} replace />
        ))}
    </>
  );
};
